"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IframeType = void 0;
var IframeType;
exports.IframeType = IframeType;

(function (IframeType) {
  IframeType["Website"] = "website";
  IframeType["Amp"] = "amp";
})(IframeType || (exports.IframeType = IframeType = {}));